// components/ToolCard.js
import React from 'react';
import '../styles/ViewTools.css'
import { AiOutlineMinusCircle, AiOutlineExclamationCircle, AiOutlineLike } from "react-icons/ai";

// Tool Card component for displaying a tool's information in a card format
const ToolCard = ({ tool, onViewMore }) => {
    const restrictionIcon = () => {
        if (tool.restriction === 'safe') {
            return <AiOutlineLike title="No adult supervision needed" />;
        } else if (tool.restriction === 'cautious') {
            return <AiOutlineMinusCircle title="Adult supervision needed" />;
        } else if (tool.restriction === 'danger') {
            return <AiOutlineExclamationCircle title="Not allowed for student use" />;
        }
    };
    return (
        <div className="tool-card">
            <img src={tool.imageUrl} alt={tool.tool_name} className="tool-image" />
            <div className="tool-info">
                <h3>
                    {tool.tool_name}
                    <span className={`status-icon`}>
                        {restrictionIcon()}
                    </span>
                </h3>
                <p>{tool.tool_model}</p>
                <p className="tool-category">{tool.tool_category}</p>
            </div>
            <button onClick={() => onViewMore(tool._id)} className="view-more-btn">Learn More {'>>'}</button>
        </div>
    );
};

export default ToolCard;